export default __webpack_public_path__ + "static/media/set5.2ef5bde0.jpeg";